import Axios from "axios";
import { API_URL } from "../config/env";
import { transformSpotLight, transformProduct, transformCategory } from "./helpers";
import { SpotLight, Product, Category } from "../types";

export async function getSpotLights(type: "ALL" | "FEATURED" | "NOT_FEATURED" = "ALL"
): Promise<SpotLight[]> {
    let filter = 'status=Active&';
    if (type == "NOT_FEATURED") {
        filter += "is_featured=0"
    } else if (type == "FEATURED") {
        filter += "is_featured=1"
    }
    const {
        data: { data },
    } = await Axios.get(`${API_URL}/spotlights?${filter}`);
    return data.map(transformSpotLight);
}

export async function getDealsProducts(
): Promise<Product[]> {
    const {
        data: { data },
    } = await Axios.get(`${API_URL}/products/offer`);
    return data.map(transformProduct);
}


export async function getCategoryDiscover(
): Promise<Category[]> {
    const {
        data: { data },
    } = await Axios.get(`${API_URL}/categories/discovered`);
    return data.map(transformCategory);
}

